<template>
	<div class="row">
		<div class="col-xl-3 col-md-6 mb-4">
			<bga2-info-card classe="border-left-danger">
		    	<div class="col mr-2">
					<div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
						Dia
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.despesaDia }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
		<div class="col-xl-3 col-md-6 mb-4">
			<bga2-info-card classe="border-left-danger">
		    	<div class="col mr-2">
					<div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
						Semana
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.despesaSemana }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
		<div class="col-xl-3 col-md-6 mb-4">
			<bga2-info-card classe="border-left-danger">
		    	<div class="col mr-2">
					<div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
						Mês
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.despesaMes }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
		<div class="col-xl-3 col-md-6 mb-4">
		    <bga2-info-card classe="border-left-danger">
		    	<div class="col mr-2">
					<div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
						Ano
					</div>
					<div class="h5 mb-0 font-weight-bold text-gray-800">	
						R$ {{ dados.despesaAno }}
					</div>
				</div>
				<div class="col-auto">
					<i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
				</div>
		    </bga2-info-card>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				dados: []
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/despesas/data?data='+this.date)
	            .then(response => {
	            	this.dados = response.data;
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
		},
		watch: {
			date(){
				if(this.date){
					this.getDados()
				}
			}
		}
	}
</script>